// extracted by mini-css-extract-plugin
export var img = "Slide-module--img--9bgvM";
export var caption = "Slide-module--caption--ZKnB3";
export var title = "Slide-module--title--tq4BR";
export var category = "Slide-module--category--9CI6o";
export var link = "Slide-module--link--jj5qJ";
export var focusVisible = "Slide-module--focus-visible--qmmU2";